import React, { useEffect, useRef, useState } from "react";
import Table from "../../../components/DetailsTable";
import { Card as CardContainer } from "../../../styles";
import { Row, Col } from "react-bootstrap";
import styled from "styled-components";
import { Card } from "../../../components/DetailsTable";
import { LoadMoreContainer } from "../../../components/Dialog/EditFormBottom";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation, useParams } from "react-router";
import { Spinner } from "react-bootstrap";
import { isNull, isEmpty } from "lodash";
import moment from "moment";
import Select, { components } from "react-select";
import validator from "validator";
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import {
  getPatientById,
  getAppointmentByPatientId,
  getReportByPatientId,
  getRecommendationByPatientId,
  getMessagesByPatientPhoneNumber,
  getNotes,
  getPrescriptionByPatientId,
  getEmailsByPatientId,
  getPatientByMrn,
  updatePatientDetails,
  getCohortsByPatientId,
  changeActionStatusActionPatientDetails,
  getLettersByPatientId,
  changeLetterStatusPatientDetails,
  getSecuredSMSByPatientId,
  getFaxesByPatientId,
  getReportCohortsByPatientId,

} from "../../../actions/radminUploads";
import { InfoIconOutline as InfoButtonIcon } from "../Messages/Icons";
import { TemplateButton } from "../Messages/SmsCreationDialog";
import { StatusBadge } from "../Messages/Messages";
import { StatusBadge as MessageStatus } from "../Messages/MessageDeliveriesIncoming";

import ShowMessageContent from "../Messages/ShowMessageContent";
import EditReco from "../../../components/Dialog/EditReco";
import { PaginationLeftArrow, PaginationRightArrow } from "../Cohorts/Icons";
import Flex from "../../../components/_styles/Flex";
import BackButton from "../../../components/BackButton";
import { Box, Popover } from '@material-ui/core';
import ActionStatusList from "../FollowUpList/ActionStatusList";
import NewNote from "../../../components/Dialog/NewNote";
import { showAlert } from "../../../actions/radminUploads";
import { ReactComponent as ConditionalIcon } from '../../../assets/conditional-icon.svg';
import ViewReportModal from "../Messages/ViewReportModal";
import { ReactComponent as DownArrow } from "../../../assets/dropdown-outline-white.svg";
import TimelineComponent from "./TimelineComponent";
import { ReactComponent as FollowupRecommendedIcon } from '../../../assets/follow-up-recommended-icon.svg';
import { parseQuery } from "../RecommendationCohorts/util";
import DescriptionChipGroups from "../RecommendationCohorts/DescriptionChipGroups";


const Heading = styled.p`
    font-weight: 700;
    font-size: 24px;
    line-height: 28.8px;
    font-family: 'Roboto Condensed';
    color: #0C2945;
`;
const PatientInfoHeading = styled.p`
  color: #B2B2B3;
  font-size: 14px;
  font-weight: 600;
  font-family: Open Sans;
  line-height: 15.08px;
  margin-bottom:8px;
`;
const PatientInfo = styled.p`
  font-size: 20px;
  color: #3e3f41;
  font-size: 14px;
  font-weight: 400;
  font-family: Open Sans;
  line-height: 17.6px; 
  max-width:100px;
  word-wrap:break-word;
`;
const PatientName = styled.p`
  font-size: 20px;
  color: #000000;
  font-size: 20px;
  font-weight: 600;
  font-family: Open Sans;
  line-height: 17.6px;
  margin-bottom:0px;
`;
const Container = styled.div`
  margin: 0 auto;
  width: 95%;
  margin-top: 27px;
`;

export const NotesContainer = styled.div`
  background: #ffffff;
  border: 1px solid #c2ccd9;
  box-sizing: border-box;
  margin: 0 0 20px 0;
  border-radius: 8px;
  padding:  23px;
  height: 25rem;
`;
export const TableContainer = styled.div`
  background: #ffffff;
  border: 1px solid #c2ccd9;
  box-sizing: border-box;
  margin: 0 0 20px 0;
  border-radius: 8px;
  padding: 30px;
`;

const PageContainer = styled.div`
  font-family: "Roboto Condensed";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items:center;
`;
const IconContainer = styled.div`
  cursor: pointer;
  padding-right: ${(props) => props.paddingRight};
  padding-left: ${(props) => props.paddingLeft};
  display:flex;
  align-items:center;
  gap:4px;
`;

const SelectContainer = styled.div`
  width: 250px;
  & div.select__control, div.select__value-container {
    height: 38px;
   }
`;

const SelectDropdownTitle = styled.div`
  margin-bottom: 4px;
  font-family: Roboto Condensed;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  color: #6d6e6e;
  text-transform: uppercase;
`;

const DescriptionValue = styled.div`
  font-family: Roboto Condensed;
  font-style: normal;
  font-size: 14px;
  text-align: initial;
  color: #000000;
  margin: 0px;
  display:flex;
  gap:15px;
  flex-wrap:wrap;
`;


const ContainerHeader = styled.div`
display:flex;
justify-content:space-between;
align-items:center;
margin-bottom:25px;
`

const languageOptions = [
  { value: "en", label: "English (default)" },
  { value: "spa", label: "Spanish" },
];

const genderOptions = [
  { value: "male", label: "Male" },
  { value: "female", label: "Female" },
  { value: "non_binary", label: "Non Binary" },
  { value: "other", label: "Other" },
  { value: "unknown", label: "Unknown" },
];

const phoneClosedOptions = [
  { value: true, label: "Yes" },
  { value: false, label: "No" },
];

const phoneUnsubscribedOptions = [
  { value: true, label: "Yes" },
  { value: false, label: "No" },
];



const FaxBadge = styled(Flex)`
  width: 112px;
  min-width: 54px;
  padding: 0 5px;
  height: 24px;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  color: white;
  font-size: 14px;
  font-weight: 600;
  text-transform: capitalize;
  background: ${(props) => {
    switch (props.status) {
      case "success":
        return "#64C67C";

      case "failed":
        return "#9B64C6";

      case "cancelled":
        return "#CF3131";

      case "transmitting":
        return "#FF7A00";

      case "processing":
        return "#ADADAD";

      default:
        return "#DFE0EB";
    }
  }};
`;


const FaxStatus = ({ status }) => (
  <FaxBadge status={status}>{status}</FaxBadge>
);


const IndicatorsContainer = (props) => {
  return (
    <>
      <components.Option {...props}>
        <span style={{ marginRight: 5, paddingTop: 5 }}>
          <input
            type="radio"
            checked={props.isSelected}
            onChange={() => null}
            style={{ marginTop: 5 }}
          />{" "}
        </span>
        <label>{props.label}</label>
      </components.Option>
    </>
  );
};

const Badge = styled(Flex)`
  width: 140px;
  min-width: 54px;
  padding: 0 5px;
  height: 24px;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  margin-left:0;
  border-radius: 100px;
  color: white;
  background: ${(props) => {
    switch (props.status) {
      case "sent":
        return "#FDBB13";

      case "delivered":
        return "#64C67C";

      case "opened":
        return "#00AEEF";

      case "clicked":
        return "#4EAC9F";

      case "spammed":
        return "#7C7C7C";

      case "failed":
        return "#9B64C6";

      case "dropped":
        return "#CF3131";

      case "bounced":
        return "#FF5F65";

      case "unsubscribed":
        return "#ADADAD";

      case "converted":
        return "#FF7A00";

      default:
        return "#DFE0EB";
    }
  }};
`;
const EmailStatusBadge = ({ status }) => (
  <Badge status={status}>{status}</Badge>
);

const recommendationColumns = [
  {
    key: "accessionNumber",
    name: "Accession Number",
  },
  {
    key: "initialExamDate",
    name: "Exam Date",
  },
  {
    key: "modality",
    name: "Reco Modality",
  },
  {
    key: "anatomy",
    name: "Reco Anatomy",
  },
  {
    key: "rangeStart",
    name: "Range Start",
  },
  {
    key: "rangeEnd",
    name: "Range End",
  },
];

const recoHistoryData = [
  { key: "accession_number", name: "Accession Number", align: "left" },
  {
    key: "status_override_from",
    name: "Status Override From",
    displayCell: (status) =>
      status ? (
        <StatusBadge
          styles={{ marginLeft: 0 }}
          status={status}
          dropDown={false}
        />
      ) : (
        "No Status"
      ),
    align: "left",
    paddingLeft:'74px'
  },
  {
    key: "status_override_to",
    name: "Status Override To",
    displayCell: (status) =>
      status ? (
        <StatusBadge
          styles={{ marginLeft: 0 }}
          status={status}
          dropDown={false}
        />
      ) : (
        "No Status"
      ),
    align: "left",
  },
  { key: "user_rejected_status",
    name: "User Rejected Status",
    align: "left",
    displayCell: (value) => 
    value ? (
      <RemoveRecoText value={value} />) : ("Not Rejected")
  },
  {
    key: "changed_at",
    name: "Changed At",
    displayCell: (cellValue) => moment(cellValue)?.format('YYYY-MM-DD') ,
    align: "left",
  },
  { key: "user", name: "User", align: "left" }
];


const RemoveRecoText = ({ value }) => (
  <td style={{ fontStyle: 'italic', color: 'red' }}>{value ? "Rejected" : "Not Rejected"}</td>

);

const reportColumns = [
  {
    key: "accessionNumber",
    name: "Accession Number",
  },
  {
    key: "modality",
    name: "Modality",
  },
  {
    key: "initialExamDate",
    name: "Exam Date",
  },
  {
    key: "referring_physician?.unique_id",
    name: "Physician NPI",
     displayCell: (cellValue, row, idx) => (
        <span>{row?.referring_physician?.unique_id ?? '-'}</span>
        ),
  },
  {
    key: "location_address",
    name: "Location Address"
  },
  {
    key: "exam_code",
    name: "Exam Code"
  },
  {
    key: "exam_description",
    name: "Exam Description"
  },
  {
    key: "follow_up_recommended",
    name: "Follow up Recommended",
     displayCell: (cellValue, row, idx) => (
        <span>{row?.follow_up_recommended ?  <FollowupRecommendedIcon /> : null}</span>
        ),
  },
];

const appointmentsColumns = [
  {
    key: "initial_exam_date",
    name: "Scheduled Exam Date",
  },
  {
    key: "exam_description",
    name: "Exam Description",
  },
  {
    key: "care_type",
    name: "Care Type",
  },
];

const prescriptionsColumns = [
  {
    key: "id",
    name: "ID",
  },
  {
    key: "accession_number",
    name: "Accession Number",
  },
  {
    key: "referring_physician",
    name: "Referring Physician",
  },
  {
    key: "patient",
    name: "Patient",
  },
  {
    key: "exam_description",
    name: "Exam Description",
  },
  {
    key: "modality",
    name: "Modality",
  },
  {
    key: "ordered_time",
    name: "Ordered Time",
  },
];

const messagesColumns = [
  {
    key: "created",
    name: "Created Date",
  },
  {
    key: "twilio_status",
    name: "Status",
    displayCell: () => <MessageStatus />,
  },
  {
    key: "direction",
    name: "Direction",
  },
  {
    key: "cio_campaign_name",
    name: "Campaign Title",
    displayCell: (cellValue) => (
      <div>{cellValue || '-'}</div>
    )
  },
  {
    key: "message_ssid",
    name: "Message SSID",
  },
  
  {
    key: "viewContent",
    displayCell: () => (
      <TemplateButton
        title="View Content"
        color="#00AEEF"
        border={true}
        outlinedBr={"#00AEEF"}
        icon={<InfoButtonIcon />}
        clickHandler={() => alert("view content clicked")}
      />
    ),
  },
];

const emailsColumns = [
  {
    key: "created",
    name: "Created Date",
  },
  {
    key: "status",
    name: "Status",
    displayCell: (status) => <EmailStatusBadge status={status} />,
  },
  {
    key: "recipient_mrn",
    name: "Recipient MRN",
  },
  {
    key: "recipient_email",
    name: "Recipient Email",
  },
  {
    key: "cio_campaign_name",
    name: "Campaign Title",
    displayCell: (cellValue) => (
      <div>{cellValue || '-'}</div>
    )
  },
];

const notesColumns = [
  {
    key: "id",
    name: "Id",
  },
  {
    key: "user",
    name: "User",
  },
  {
    key: "created",
    name: "Created Date",
  },
  {
    key: "note_title",
    name: "Note Title",
  },
  {
    key: "note_content",
    name: "Note Content",
  },
];


const faxesColumns = [
  {
    key: "created",
    name: "Created Date",
  },
  {
    key: "status",
    name: "Status",
    displayCell: () => <FaxStatus />,
  },
  {
    key: "direction",
    name: "Direction",
  },
  {
    key: "cio_campaign_name",
    name: "Campaign Title",
    displayCell: (cellValue) => (
      <div>{cellValue || '-'}</div>
    )
  },
 
  
  {
    key: "viewContent",
    displayCell: () => (
      <TemplateButton
        title="View Content"
        color="#00AEEF"
        border={true}
        outlinedBr={"#00AEEF"}
        icon={<InfoButtonIcon />}
        clickHandler={() => alert("view content clicked")}
      />
    ),
  },
];


const SaveButton = styled.button`
  width: 129px;
  height: 38px;
  background-color: ${props=> props.disabled? '#00AEEF4D':'#00aeef'};
  color: #ffffff;
  border-radius: 4px;
  border: 0;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  text-align: center;
  cursor: pointer;
`;

const cohortsColumns = [
    {
        key:'cohort_title',
        name:'Cohort Name'
    },
    {
        key:'description',
        name:'Cohort Description'
    },
]

const securedMessagesColumns = [
  {
    key: "created",
    name: "Created Date",
  },
     {
    key: "status",
    name: "Status",
    displayCell: (cellValue) => <SecuredSMSStatusBadge status={cellValue} />,
  },
  {
    key: "message",
    name: "Follow Up Message",
  },
 
];



const StatusesContainer = styled.div`
  cursor: pointer;
  border-radius: 8px;
  width:244px;

`

const HeaderLinks = styled.span`
color:#00AEEF;
font-weight:400;
font-size:14px;
font-family:Open Sans;
cursor:pointer;
`


 const HeaderCard = styled.div`
  background: #FFFFFF;
  border:${props => !props.paginated && '1px solid #C2CCD9'} ;
  box-sizing: border-box;
  margin-bottom:26px;
  border-radius:${props => !props.paginated && '8px'};
  padding: 30px;
  width: ${props => props.isTimeLineHeight && `94.2vw` };
  overflow-x: ${props => props.isTimeLineHeight ? `hidden`: `auto` };
  overflow-y: ${props => props.isTimeLineHeight && `hidden` }; 
  height: ${props => props.isTimeLineHeight ? `${props.isTimeLineHeight}px` : `265px`}; 
`

const LetterBadge = styled(Flex)`
  width: fit-content;
  min-width: 54px;
  padding: 0 5px;
  height: 24px;
  cursor: pointer;
  align-items: center;
  text-transform: capitalize;
  border-radius: 100px;
  font-size: 11px;
  font-weight: 600;
  font-family: Open Sans;
  white-space: nowrap;
  padding: 5px 16px 5px 16px;
  color: white;
  background: ${(props) => {
    switch (props.status) {
      case "printed": 
      return "#F7D62B";
      case "mailed": 
      return "#64C67C";
      default:
        return "#DFE0EB";
    }
  }};
`;

const LetterStatusBadge = ({ status, onClick }) => (
  <LetterBadge status={status} onClick={onClick}>
    {status}
    <DownArrow style={{ marginLeft: "10px" }} />
  </LetterBadge>
);


const Status = styled.p`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-right: 16px;
  padding-left:16px;
  height: 25px;
  width: 100%;
  border-radius: 12px;
  // border: ${props => props.fromMessage === "true"? `2px solid ${props.color}` : "none"}
  background-color: ${props => props.color};
  font-style: normal;
  font-weight: 600;
  font-size: 11px;
  font-family:Open Sans;
  line-height: 15px;
  letter-spacing: 0.2px;
  color:#FFFFFF;
  white-space: no-wrap;
  margin-bottom: 12px;
`

const StatusIconContainer = styled.span`
  // margin-right: 8px;
`

const ActionList = styled.ul`
padding: 12px;
list-style: none;
margin-bottom:0;
& li:last-child p{
  margin-bottom: 0;
}
`

const ActionItem = styled.li`
  margin: 0px;
  padding: 0;
  min-width: 101px;
  cursor:pointer;
`

const SecuredSMSBadge = styled(Flex)`
  width: 112px;
  min-width: 54px;
  padding: 0 5px;
  height: 24px;
  cursor: pointer;
  justify-content:center;
  align-items: center;
  text-transform: capitalize;
  border-radius: 100px;
  font-size: 11px;
  font-weight: 600;
  font-family: Open Sans;
  white-space: nowrap;
  padding: 5px 16px 5px 16px;
  color: white;
  background: ${(props) => {
    switch (props.status) {
      case "drafted":
        return "#FDBB13";

      case "opened":
        return "#00AEEF";

      case "clicked":
        return "#64C67C";
      default:
        return "#DFE0EB";
    }
  }};
`;



const SecuredSMSStatusBadge = ({ status }) => (
  <SecuredSMSBadge status={status}>{status}</SecuredSMSBadge>
);


const ActionStatus = ({status, color, fromMessage, selectedStatus}) => {
  return (
    <Status selectedStatus={selectedStatus === status} color={color} fromMessage={fromMessage}>
      {status} 
    </Status>
  )
}

const actionStatuses = [
  {status: 'Printed', color: '#F7D62B', value:'printed'},
  {status: 'Mailed', color: '#64C67C', value:'mailed'},
]


const PatientDetails = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const mrnValue = searchParams.get("MRN");
  const { id } = useParams();
  const [patientId, setPatientId] = useState();
  const isMergedPatient = searchParams.get("mergedPatient") === "true";
  const history = useHistory()
  const [letterAnchorEl, setLetterAnchorEl] = React.useState(null);
  const [openedLetterRow, setOpenedLetterRow] = useState();

  const letterHandleClick = (event,row) => {
    setLetterAnchorEl(event.currentTarget);
    setOpenedLetterRow(row)
  };


  const reportCohortsColumns = [
   {
        key:'id',
        name:'Cohort Id'
    },
    {
        key:'title',
        name:'Cohort Name'
    },
    {
        key:'description',
        name:'Cohort Description',
         displayCell: (cellValue, rowData) => {
                const { parents, operators } = parseQuery(cellValue);
              return ( 
                <DescriptionValue>
                <DescriptionChipGroups parents={parents} operators={operators} whiteSpace="wrap" />
                </DescriptionValue>
              ) 
            }
    },
     {
        key:'trigger_cio_event',
        name:'Messaging Campaign',
          displayCell: (cellValue, rowData) => {
              
              return ( 
                <span>{String(cellValue)}</span>
              ) 
            }
    },
    {
      key:'computed_status_criteria',
      name: 'Computed Status Criteria',
        displayCell: (cellValue, rowData) => {
              return ( 
                <span               style={{ color: "#1890ff", textDecoration: "underline", cursor:'pointer' }}
 onClick={()=>{
                   history.push(`/auth/radAdmin/settings?type=report-settings-status&id=${rowData?.computed_status_criteria?.id}` ,                        { data: rowData?.computed_status_criteria }
)
                }}>{rowData?.computed_status_criteria?.name}</span>
              ) 
            }
    }
]


  const lettersColumns = [
    {
      key: "created_at",
      name: "Printed Date",
    },
    {
      key: "status",
      name: "Status",
      displayCell: (status, row) =>   <>
        <LetterStatusBadge 
          onClick={(e)=> letterHandleClick(e,row)} 
          status={status} />
        </>  
    },
    {
      key: "direction",
      name: "Direction",
    },
  ];


  const patientDetails = useSelector(
    (state) => state.radAdmin.patientDetails?.data
  );
  const patientAppointmentRow = useSelector(
    (state) => state.radAdmin.patientDetails.appointments?.data
  );
  const patientReportRow = useSelector(
    (state) => state.radAdmin.patientDetails.reports?.data
  );

  const patientRecosRow = useSelector(
    (state) => state.radAdmin.patientDetails.recommendations?.data
  );
  const patientLettersRow = useSelector(
    (state) => state.radAdmin.patientDetails.letters?.data
  );



   const patientFaxesRow = useSelector(
    (state) => state.radAdmin.patientDetails.faxes?.data
  );
   const patientSecuredSMSRow = useSelector(
    (state) => state.radAdmin.patientDetails.securedSMS?.data
  );

  const notesData = useSelector((state) => state.radAdmin.notes?.data);
  const messages = useSelector(
    (state) => state.radAdmin.patientDetails.messages?.data
  );
  const emails = useSelector(
    (state) => state.radAdmin.patientDetails.emails?.data
  )?.map((itm) => ({
    ...itm,
    recipient_email: (patientDetails && patientDetails?.email) || "N/A",
    recipient_mrn: patientDetails?.mrn || "N/A",
  })) ?? null ;


  const totalMessages = useSelector(
    (state) => state.radAdmin.patientDetails.messages?.totalItems
  );
  const totalEmails = useSelector(
    (state) => state.radAdmin.patientDetails.emails?.totalItems
  );

  const totalCohorts = useSelector(state => state.radAdmin.patientDetails.cohorts?.totalItems);

 const totalReportCohorts = useSelector(state => state.radAdmin.patientDetails.reportCohorts?.totalItems);


  const prescriptions = useSelector(
    (state) => state.radAdmin.patientDetails.prescriptions?.data
  )?.map((itm) => ({
    ...itm,
    patient:
      (patientDetails &&
        patientDetails.first_name + " " + patientDetails.last_name) ||
      "N/A",
  }));

  const cohorts = useSelector(state => state.radAdmin.patientDetails.cohorts?.data);
  const reportCohorts = useSelector(state => state.radAdmin.patientDetails.reportCohorts?.data);


  const isLoadingAppointments = useSelector(
    (state) => state.radAdmin.patientDetails.appointments.isLoading
  );
  const isLoadingPrescriptions = useSelector(
    (state) => state.radAdmin.patientDetails.prescriptions?.isLoading
  );
  const isLoadingReco = useSelector(
    (state) => state.radAdmin.patientDetails.recommendations.isLoading
  );
  const isLoadingLetters = useSelector(
    (state) => state.radAdmin?.patientDetails?.letters?.isLoading
  );

   const isLoadingFaxes = useSelector(
    (state) => state.radAdmin?.patientDetails?.faxes?.isLoading
   );
   const isLoadingSecuredSMS = useSelector(
    (state) => state.radAdmin?.patientDetails?.securedSMS?.isLoading
  );
  const isLoadingMessages = useSelector(
    (state) => state.radAdmin.patientDetails.messages.isLoading
  );
  const isLoadingEmails = useSelector(
    (state) => state.radAdmin.patientDetails.emails.isLoading
  );
  const isLoadingReports = useSelector(
    (state) => state.radAdmin.patientDetails.reports.isLoading
  );
  const isLoadingPatient = useSelector(
    (state) => state.radAdmin.patientDetails.isLoading
  );
  const isLoadingNotes = useSelector(
    (state) => state.radAdmin.notes?.isLoading
  );
  const isLoadingCohorts = useSelector(state => state.radAdmin.patientDetails.cohorts?.isLoading);
    const isLoadingReportCohorts = useSelector(state => state.radAdmin.patientDetails.reportCohorts?.isLoading)


  const totalNotes = useSelector((state) => state.radAdmin.notes?.totalItems);
  const totalPrescriptions = useSelector(
    (state) => state.radAdmin.patientDetails.prescriptions?.totalItems
  );
  const totalAppointments = useSelector(
    (state) => state.radAdmin.patientDetails.appointments?.totalItems
  );
  const totalReports = useSelector(
    (state) => state.radAdmin.patientDetails.reports?.totalItems
  );
  const totalRecommendations = useSelector(
    (state) => state.radAdmin.patientDetails.recommendations?.totalItems
  );

  const totalLetters = useSelector(
    (state) => state.radAdmin.patientDetails.letters?.totalItems
  );

  const totalSecuredSMS = useSelector(
    (state) => state.radAdmin.patientDetails.securedSMS?.totalItems
  );
 

  const totalFaxes = useSelector(
    (state) => state.radAdmin.patientDetails.faxes?.totalItems
  );

  const permission = useSelector((state) => state.auth.user.permission_level); 

  const rolePermissions = useSelector(
    (state) =>state.auth.user.permissions
  );
  const updatePermission = rolePermissions?.find(itm=>itm.name ==="Patients")?.permissions.find(itm=>itm.codename === "change_patients")?.is_authorized;
  const addPermission =  rolePermissions?.find(itm=>itm.name ==="Patients")?.permissions.find(itm=>itm.codename === "add_patients")?.is_authorized;

  const [pageForSMS, setPageForSMS] = useState(1);
  const [selectedMessage, setSelectedMessage] = useState(null);
  const [selectedEmail, setSelectedEmail] = useState(null);
  const [openReportDetails, setOpenReportDetails] = useState(false);
  const [openReportIndex, setOpenReportIndex] = useState()

  const [selectedLetters, setSelectedLetters] = useState(null);
  const [selectedFax, setSelectedFax] = useState(null);

  const [selectedData, setSelectedData] = useState(null);
  const [requiredReco, setRequiredReco] = useState(null);
  const [isSelectedData, setIsSelectedData] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [appointmentsPageNumber, setAppointmentsPageNumber] = useState(1);
  const [reportsPageNumber, setReportsPageNumber] = useState(1);
  const [recommendationsPageNumber, setRecommendationsPageNumber] = useState(1);
  const [lettersPageNumber, setLettersPageNumber] = useState(1);
  const [securedSMSPageNumber, setSecuredSMSPageNumber] = useState(1);

    const [faxesPageNumber, setFaxesPageNumber] = useState(1);

  const [prescriptionPageNumber, setPrescriptionPageNumber] = useState(1);
  const [cohortsPageNumber, setCohortsPageNumber] = useState(1);
    const [reportCohortsPageNumber, setReportCohortsPageNumber] = useState(1)

  const [emailPageNumber, setEmailPageNumber] = useState(1);
  const [selectedLanguage, setSelectedLanguage] = useState();
  const [selectedGender, setSelectedGender] = useState();
  const [selectedPhoneUnsubcribed, setSelectedPhoneUnsubscribed] = useState();
  const [selectedPhoneClosed, setSelectedPhoneClosed] = useState();
  const [selectedPatientEmail, setSelectedPatientEmail] = useState();
  const [timelineData, setTimelineData] = useState();
  const [selectedPatientPhoneNumber, setSelectedPatientPhoneNumber] =
    useState();
  const [selectedPatientFirstName, setSelectedPatientFirstName] = useState();
  const [selectedPatientLastName, setSelectedPatientLastName] = useState();

  const recoConfigData = useSelector((state) => state.radAdmin.recoConfig.data);
  const node = useRef();
  const letterNode = useRef();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [openedRow, setOpenedRow] = useState();
  const [loading, setLoading] = useState(false);

  const handleClick = (event,id) => {
    setAnchorEl(event.currentTarget);
    setOpenedRow(id)
  };

  const handleLetterClose = () => {
    setLetterAnchorEl(null);
    setOpenedLetterRow()
  };


  const handleClose = () => {
    setAnchorEl(null);
    setOpenedRow()
  };

  const open = Boolean(anchorEl);
  const popupId = open ? 'simple-popover' : undefined;

  const letterOpen = Boolean(letterAnchorEl);
  const letterPopupId = letterOpen ? 'simple-popover-letter' : undefined;

  useEffect(() => {
    if (patientDetails) {
      setSelectedLanguage(
        languageOptions.find(
          (itm) => itm.value === patientDetails?.language_preference
        )
      );
      setSelectedPhoneClosed(
        phoneClosedOptions.find(
          (itm) => itm.value === patientDetails?.phone_closed
        )
      );
      setSelectedPhoneUnsubscribed(
        phoneUnsubscribedOptions.find(
          (itm) => itm.value === patientDetails?.phone_unsubscribed
        )
      );
      setSelectedGender(
        genderOptions.find((itm) => itm.value === patientDetails?.gender)
      );
      setSelectedPatientEmail(patientDetails?.email);
      setSelectedPatientPhoneNumber(patientDetails?.phone_number);
      setSelectedPatientFirstName(patientDetails?.first_name);
      setSelectedPatientLastName(patientDetails?.last_name);
    }
  }, [patientDetails]);

  const notesRows = notesData?.map((note) => {
    return {
      id: note?.id,
      user: note?.user?.name,
      created: moment(note?.created).format("DD-MM-YYYY"),
      note_title: note?.title,
      note_content: note?.note_text,
    };
  });
  const totalNotesPages = Math.ceil(totalNotes / 10);
  const totalPrescriptionsPages = Math.ceil(totalPrescriptions / 10);
  const totalCohortsPages = Math.ceil(totalCohorts/10);
  const totalAppointmentsPages = Math.ceil(totalAppointments / 10);
  const totalRecommendationsPages = Math.ceil(totalRecommendations / 10);
  const totalReportsPages = Math.ceil(totalReports / 10);
    const totalReportCohortsPages = Math.ceil(totalReportCohorts/10);


  useEffect(() => {
    if (!id) {
      dispatch(getPatientByMrn(mrnValue))
        .then((res) => setPatientId(res.id))
        .catch((err) => console.log(err));
    }
  }, [dispatch, id, mrnValue]);

  useEffect(() => {
    if (id || patientId) {
      const params = isMergedPatient ? { is_active: false } : {};
      dispatch(getPatientById(id || patientId, params));
    }
  }, [dispatch, id, patientId, isMergedPatient]);

  useEffect(() => {
    if (selectedData) {
      setRequiredReco(selectedData);
      setIsSelectedData(true);
    }
  }, [selectedData]);

  useEffect(() => {
    if (!isNull(patientDetails) && patientDetails.phone_number) {
      dispatch(
        getMessagesByPatientPhoneNumber(patientDetails.phone_number, pageForSMS)
      );
    }
  }, [dispatch, pageForSMS, patientDetails]);


  useEffect(() => {
    if (id || patientId) {
      dispatch(getAppointmentByPatientId((id || patientId), appointmentsPageNumber));
    }
  }, [appointmentsPageNumber, id, patientId]);

  useEffect(() => {
    if (id || patientId) {
      dispatch(getRecommendationByPatientId(id || patientId, recommendationsPageNumber));
    }
  }, [recommendationsPageNumber, id, patientId]);

  useEffect(() => {
    if (id || patientId) {
      dispatch(getFaxesByPatientId(id || patientId, faxesPageNumber));
    }
  }, [ id, faxesPageNumber, patientId]);


  useEffect(() => {
    if (id || patientId) {
      dispatch(getLettersByPatientId(id || patientId, lettersPageNumber));
    }
  }, [ id, lettersPageNumber, patientId]);

  useEffect(() => {
    if (id || patientId) {
      dispatch(getReportByPatientId(id || patientId, reportsPageNumber));
    }
  }, [reportsPageNumber, id, patientId]);

  useEffect(() => {
    if (id || patientId) {
      dispatch(getNotes(parseInt(id || patientId), pageNumber));
    }
  }, [pageNumber, id, patientId]);

  useEffect(() => {
    if (id || patientId) {
      dispatch(
        getPrescriptionByPatientId(
          parseInt(id || patientId),
          prescriptionPageNumber
        )
      );
    }
  }, [prescriptionPageNumber, id, patientId]);

  useEffect(() => {
    if (id || patientId) {
      dispatch(
        getEmailsByPatientId(parseInt(id || patientId), emailPageNumber)
      );
    }
  }, [ id, emailPageNumber, patientId]);

  useEffect(() => {
    if(id || patientId){
    dispatch(getCohortsByPatientId(parseInt(id || patientId), cohortsPageNumber))
    }
},[cohortsPageNumber, id, patientId])


 useEffect(() => {
    if (id || patientId) {
      dispatch(getSecuredSMSByPatientId(id || patientId, securedSMSPageNumber));
    }
  }, [ id, securedSMSPageNumber, patientId]);
 useEffect(() => {
    if(id || patientId){
    dispatch(getReportCohortsByPatientId(parseInt(id || patientId), reportCohortsPageNumber))
    }
},[reportCohortsPageNumber, id, patientId])

  const dialogHandler = () => {
    setSelectedMessage(null);
    setSelectedEmail(null);
    setSelectedLetters(null);
        setSelectedFax(null);

  };
  

  const editModalHandle = () => {
    setSelectedData(null);
    setIsSelectedData(false);
  };

  const LoadMoreMessages = () => {
    window.analytics.track("Patient-Details-Load-More-Messages-Click");
    setPageForSMS(pageForSMS + 1);
  };

  const LoadMoreEmails = () => {
    window.analytics.track("Patient-Details-Load-More-Emails-Click");
    setEmailPageNumber(emailPageNumber + 1);
  };


  const LoadMoreFaxes = () => {
    window.analytics.track("Patient-Details-Load-More-Faxes-Click");
    setFaxesPageNumber(faxesPageNumber + 1);
  };

  const LoadMoreLetters = () => {
    window.analytics.track("Patient-Details-Load-More-Letters-Click");
    setLettersPageNumber(lettersPageNumber + 1);
  };


  const LoadMoreSecuredSMS = () => {
    window.analytics.track("Patient-Details-Load-More-Secured-SMS-Click");
    setSecuredSMSPageNumber(securedSMSPageNumber + 1);
  };


  const handlePreviousPage = () => {
    window.analytics.track("Patient-Details-Notes-Previous-Click");
    pageNumber > 1 && setPageNumber(pageNumber - 1);
  };

  const handleNextPage = () => {
    window.analytics.track("Patient-Details-Notes-Next-Click");
    totalNotesPages > pageNumber && setPageNumber(pageNumber + 1);
  };

  
  const handlePreviousReportsPage = () => {
    window.analytics.track("Patient-Details-Reports-Previous-Click");
    reportsPageNumber > 1 &&
      setReportsPageNumber(reportsPageNumber - 1);
  };

  const handleNextReportsPage = () => {
    window.analytics.track("Patient-Details-Reports-Next-Click");
    totalReportsPages > reportsPageNumber &&
      setReportsPageNumber(reportsPageNumber + 1);
  };


  
  const handlePreviousRecommendationsPage = () => {
    window.analytics.track("Patient-Details-Recommendations-Previous-Click");
    recommendationsPageNumber > 1 &&
      setRecommendationsPageNumber(recommendationsPageNumber - 1);
  };

  const handleNextRecommendationsPage = () => {
    window.analytics.track("Patient-Details-Recommendations-Next-Click");
    totalRecommendationsPages > recommendationsPageNumber &&
      setRecommendationsPageNumber(recommendationsPageNumber + 1);
  };

  const handlePreviousAppointmentsPage = () => {
    window.analytics.track("Patient-Details-Appointments-Previous-Click");
    appointmentsPageNumber > 1 &&
      setAppointmentsPageNumber(appointmentsPageNumber - 1);
  };

  const handleNextAppointmentsPage = () => {
    window.analytics.track("Patient-Details-Appointments-Next-Click");
    totalAppointmentsPages > appointmentsPageNumber &&
      setAppointmentsPageNumber(appointmentsPageNumber + 1);
  };


  const handlePreviousPrescriptionPage = () => {
    window.analytics.track("Patient-Details-Prescriptions-Previous-Click");
    prescriptionPageNumber > 1 &&
      setPrescriptionPageNumber(prescriptionPageNumber - 1);
  };

  const handleNextPrescriptionPage = () => {
    window.analytics.track("Patient-Details-Prescriptions-Next-Click");
    totalPrescriptionsPages > prescriptionPageNumber &&
      setPrescriptionPageNumber(prescriptionPageNumber + 1);
  };

  const handlePreviousCohortsPage = () => {
    window.analytics.track("Patient-Details-Cohorts-Previous-Click");
    cohortsPageNumber > 1 &&
      setCohortsPageNumber(cohortsPageNumber - 1);
  };

  const handleNextCohortsPage = () => {
    window.analytics.track("Patient-Details-Cohorts-Next-Click");
    totalCohortsPages > cohortsPageNumber &&
      setCohortsPageNumber(cohortsPageNumber + 1);
  };

   const handlePreviousReportCohortsPage = () => {
    window.analytics.track("Patient-Details-Reports-Cohorts-Previous-Click");
    reportCohortsPageNumber > 1 &&
      setReportCohortsPageNumber(reportCohortsPageNumber - 1);
  };

  const handleNextReportCohortsPage = () => {
    window.analytics.track("Patient-Details-Reports-Cohorts-Next-Click");
    totalReportCohortsPages > reportCohortsPageNumber &&
      setReportCohortsPageNumber(reportCohortsPageNumber + 1);
  };


  const [isValid, setIsValid] = useState(true);

  const handleEmailChange = (e) => {
    const inputEmail = e.target.value;
    setSelectedPatientEmail(inputEmail);
    const isValidEmail = validator.isEmail(inputEmail);
    setIsValid(isValidEmail);
  };

  const handlePatientFirstNameChange = (e) => {
    setSelectedPatientFirstName(e.target.value);
  }

  const handlePatientLastNameChange = (e) => {
    setSelectedPatientLastName(e.target.value);
  }


  const [openNewNote, setOpenNewNote] = useState(false);

  const addNoteClickHandler = () => {
    setOpenNewNote(!openNewNote)
    window.analytics.track('Patient-Details-New-Note-Click');
}

const [currentSection, setCurrentSection] = useState(null);

const scrollToSection = (id) => {
  const element = document.getElementById(id);
  if (element) {
    element.scrollIntoView({ behavior: 'smooth', block:'center' });
  }
};

useEffect(() => {
  if (currentSection) {
    scrollToSection(currentSection);
    setCurrentSection(null)
  }
}, [currentSection]);


const chevronHandler = (direction) =>{
  let requiredIndex = patientRecosRow.findIndex(
    (reco) => reco.id === selectedData.id
  );
  if(direction === "forward"){
    if (requiredIndex < patientRecosRow.length - 1) {
      setSelectedData(patientRecosRow[requiredIndex + 1])
    
    } else if (patientRecosRow.length <= totalRecommendations) {
      handleNextRecommendationsPage()
    }

  }else{
    if(requiredIndex !==0){
      setSelectedData(patientRecosRow[requiredIndex -1])

    }

  }
}


  return (
    <>
      <Container>
        <BackButton fallbackPath="/auth/radAdmin/followUpList" />
        <div style={{display:'flex', gap:'30px', justifyContent:'center', marginBottom:'27px'}}>
          <HeaderLinks onClick={() => setCurrentSection('patient-info')}>Patient Info</HeaderLinks>
          <HeaderLinks onClick={() => setCurrentSection('timeline')}>Timeline</HeaderLinks>
          <HeaderLinks onClick={() => setCurrentSection('reports')}>Reports</HeaderLinks>
          <HeaderLinks onClick={() => setCurrentSection('recommendations')}>Recommendations</HeaderLinks>
          <HeaderLinks onClick={() => setCurrentSection('appointments')}>Appointments</HeaderLinks>
          <HeaderLinks onClick={() => setCurrentSection('prescriptions')}>Prescriptions</HeaderLinks>
          <HeaderLinks onClick={() => setCurrentSection('cohorts')}>Cohorts</HeaderLinks>
          <HeaderLinks onClick={() => setCurrentSection('report-cohorts')}>Report Cohorts</HeaderLinks>
          <HeaderLinks onClick={() => setCurrentSection('notes')}>Notes</HeaderLinks>
          <HeaderLinks onClick={() => setCurrentSection('emails')}>Email</HeaderLinks>
          <HeaderLinks onClick={() => setCurrentSection('sms')}>SMS</HeaderLinks>
          <HeaderLinks onClick={() => setCurrentSection('letters')}>Letters</HeaderLinks>
          <HeaderLinks onClick={() => setCurrentSection('faxes')}>Faxes</HeaderLinks>
          <HeaderLinks onClick={() => setCurrentSection('secured-sms')}>Secured SMS</HeaderLinks>

        </div>
        <Row id="patient-info" style={{ marginBottom: 30 }}>
          <Col sm={12} lg={12} xl={12}>
            <HeaderCard isTimeLineHeight={360}>
            <Heading>Patient Info</Heading>

              <div style={{ display: "flex", gap:'30px', marginBottom:'16px' }}>
                <div
                  style={{ display: "flex", gap:'90px', width:"280px" }}
                >
                  <div>
                    <PatientInfoHeading>MRN</PatientInfoHeading>
                    <PatientInfo>
                      {(patientDetails && patientDetails.mrn) || "N/A"}
                    </PatientInfo>
                  </div>
                  <div>
                    <PatientInfoHeading>DATE OF BIRTH</PatientInfoHeading>
                    <PatientInfo>
                      {(patientDetails && patientDetails.date_of_birth) || "-"}
                    </PatientInfo>
                  </div>
                </div>
                <div style={{display:'flex', gap:'24px'}}>
                <SelectContainer>
                    <PatientInfoHeading>FIRST NAME</PatientInfoHeading>
                    <input
                    type="text"
                    id="email"
                    value={selectedPatientFirstName}
                    onChange={!isMergedPatient ? handlePatientFirstNameChange : undefined}
                    readOnly={isMergedPatient}
                    style={{
                      borderRadius: "4px",
                      border: "1px solid #D2D3D7",
                      padding: "9px 12px",
                      height: "38px",
                      backgroundColor: isMergedPatient ? "#f4f4f4" : "white",
                      cursor: isMergedPatient ? "not-allowed" : "text",
                    }}
                  />
                  
                  </SelectContainer>
                  <SelectContainer>
                    <PatientInfoHeading>LAST NAME</PatientInfoHeading>
                    <input
                    type="text"
                    id="email"
                    value={selectedPatientLastName}
                    onChange={!isMergedPatient ? handlePatientLastNameChange : undefined}
                    readOnly={isMergedPatient}
                    style={{
                      borderRadius: "4px",
                      border: "1px solid #D2D3D7",
                      padding: "9px 12px",
                      height: "38px",
                      backgroundColor: isMergedPatient ? "#f4f4f4" : "white",
                      cursor: isMergedPatient ? "not-allowed" : "text",
                    }}
                  />
                  
                  </SelectContainer>
              
                <SelectContainer>
                  <PatientInfoHeading>EMAIL ADDRESS</PatientInfoHeading>
                  <input
                    type="text"
                    id="email"
                    value={selectedPatientEmail}
                    onChange={!isMergedPatient ? handleEmailChange : undefined}
                    readOnly={isMergedPatient}
                    style={{
                      borderRadius: "4px",
                      border: "1px solid #D2D3D7",
                      padding: "9px 12px",
                      height:'38px',
                      backgroundColor: isMergedPatient ? "#f4f4f4" : "white",
                      cursor: isMergedPatient ? "not-allowed" : "text",
                    }}
                  />
                  {!isValid && selectedPatientEmail && (
                    <p style={{ color: "red" }}>Invalid Email Address</p>
                  )}
                </SelectContainer>
                </div>
             
              </div>

              <div style={{ display: "flex", gap:'30px', marginBottom:'16px'}}>
                               <div
                  style={{ display: "block", gap:'90px', width:"280px" }}>
                    <PatientInfoHeading>PHONE NUMBER TYPE</PatientInfoHeading>
                    <PatientInfo>
                      {(patientDetails && patientDetails.phone_number_type) || "-"}
                    </PatientInfo>
                  </div>
               
              <div style={{display:'flex', gap:"24px", flex:1}}>
                 <div style={{ display: "block", gap: "22px" }}>
             

                 <SelectContainer>
                  <PatientInfoHeading>UNSUBSCRIBED</PatientInfoHeading>
                  <Select
                    components={{ Option: IndicatorsContainer }}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    options={phoneUnsubscribedOptions}
                    value={selectedPhoneUnsubcribed}
                    isDisabled={isMergedPatient}
                    onChange={
                      !isMergedPatient
                        ? (value) => {
                            setSelectedPhoneUnsubscribed(value);
                            window.analytics.track(
                              "Patient-Details-Phone-Unsubscribed-Click"
                            );
                          }
                        : undefined
                    }
                    styles={{
                      control: (styles) => ({
                        ...styles,
                        backgroundColor: isMergedPatient ? "#f4f4f4" : "white",
                        cursor: isMergedPatient ? "not-allowed" : "default",
                      }),
                      option: (styles) => ({
                        ...styles,
                        fontSize: "14px",
                      }),
                    }}
                  />
                </SelectContainer> 
                </div>
                  <SelectContainer>
                  <PatientInfoHeading>LANGUAGE PREFERENCE</PatientInfoHeading>
                  <Select
                    components={{ Option: IndicatorsContainer }}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    options={languageOptions}
                    value={selectedLanguage}
                    isDisabled={isMergedPatient} 
                    onChange={
                      !isMergedPatient
                        ? (value) => {
                            setSelectedLanguage(value);
                            window.analytics.track(
                              "Patient-Details-Language-Preference-Click"
                            );
                          }
                        : undefined
                    }
                    styles={{
                      control: (styles) => ({
                        ...styles,
                        backgroundColor: isMergedPatient ? "#f4f4f4" : "white", 
                        cursor: isMergedPatient ? "not-allowed" : "default",
                      }),
                      option: (styles) => ({
                        ...styles,
                        fontSize: "14px",
                      }),
                    }}
                  />
                </SelectContainer> 
              <SelectContainer>
                  <PatientInfoHeading>GENDER</PatientInfoHeading>
                  <Select
                    components={{ Option: IndicatorsContainer }}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    options={genderOptions}
                    value={selectedGender}
                    isDisabled={isMergedPatient} 
                    onChange={
                      !isMergedPatient
                        ? (value) => {
                            setSelectedGender(value);
                            window.analytics.track("Patient-Details-Gender-Click");
                          }
                        : undefined
                    }
                    styles={{
                      control: (styles) => ({
                        ...styles,
                        backgroundColor: isMergedPatient ? "#f4f4f4" : "white",
                        cursor: isMergedPatient ? "not-allowed" : "default",
                      }),
                      option: (styles) => ({
                        ...styles,
                        fontSize: "14px",
                      }),
                    }}
                  />
                </SelectContainer>
              </div>
              </div>

               <div style={{ display: "flex", gap:'30px'}}>
              <div style={{display:'flex', gap:"58px", flex:1}}>
                <SelectContainer>
                  <PatientInfoHeading>PHONE NUMBER</PatientInfoHeading>
                  <PhoneInput
                  country={'us'}
                  value={selectedPatientPhoneNumber}
                  onChange={
                    !isMergedPatient
                      ? (value) => setSelectedPatientPhoneNumber(value)
                      : undefined
                  }
                  onlyCountries={['us']}
                  countryCodeEditable={!isMergedPatient}
                  disableDropdown={isMergedPatient}
                  inputStyle={{
                    height: '38px',
                    width: '250px',
                    backgroundColor: isMergedPatient ? '#f4f4f4' : 'white',
                    cursor: isMergedPatient ? 'not-allowed' : 'text',
                  }}
                  containerStyle={{ width: '250px' }}
                />
                </SelectContainer>
                 
                <SelectContainer>
                  <PatientInfoHeading>CLOSED</PatientInfoHeading>
                  <Select
                    components={{ Option: IndicatorsContainer }}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    options={phoneClosedOptions}
                    value={selectedPhoneClosed}
                    isDisabled={isMergedPatient}
                    onChange={
                      !isMergedPatient
                        ? (value) => {
                            setSelectedPhoneClosed(value);
                            window.analytics.track("Patient-Details-Phone-Closed-Click");
                          }
                        : undefined
                    }
                    styles={{
                      control: (styles) => ({
                        ...styles,
                        backgroundColor: isMergedPatient ? "#f4f4f4" : "white",
                        cursor: isMergedPatient ? "not-allowed" : "default",
                      }),
                      option: (styles) => ({
                        ...styles,
                        fontSize: "14px",
                      }),
                    }}
                  />
                </SelectContainer>
                <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginTop:'auto',
                  flex:1
                }}
              >
                <SaveButton
                   disabled={
                    isMergedPatient || (!isValid && selectedPatientEmail)
                      ? true
                      : false
                  }
                  onClick={() =>{
                    if((permission && updatePermission) || !permission){
                      setLoading(true);
                      dispatch(
                        updatePatientDetails(id || patientId, {
                          selectedLanguage,
                          selectedGender,
                          selectedPhoneClosed,
                          selectedPhoneUnsubcribed,
                          selectedPatientEmail,
                          selectedPatientPhoneNumber,
                          selectedPatientFirstName,
                          selectedPatientLastName
                        })
                      ).then(res=>setLoading(false))
                    }else{
                      dispatch(
                        showAlert('danger', 'Error', `You don't have permission to update patient`)
                      );
                    } 
                  }
                  }
                >
                   {loading? <Spinner animation="border" role="status" size="sm" /> : 'Save'}
                </SaveButton>
              </div>
              </div>
             
              </div>
            </HeaderCard>
          </Col>
        </Row>
        

          <Row id="timeline">
          <Col sm={12} lg={12} xl={12}>
            <HeaderCard 
            isTimeLineHeight= {367}
            >
              <Heading>Timeline</Heading>
              <div>
            <TimelineComponent id={id} patientId={patientId} />
            </div>

            </HeaderCard>
          </Col>
        </Row>


        <Row id="reports" style={{ marginBottom: 30 }}>
        <Col sm={12} lg={12} xl={12}>
        <div style={{width: '94.2vw'}}>
          <TableContainer>
          <Heading>Reports</Heading>
            <Table
              columns={[].concat(reportColumns.slice(0, 9),  {
                key: "id",
                displayCell: (value, rowData,idx) => (
                  <TemplateButton
                    style={{
                      height: "38px",
                      borderRadius: "4px",
                      borderWidth: "2px",
                      padding: "9px 15px",
                      width: "130px",
                      gap: "8px",
                    }}
                    border={true}
                    outlinedBr={"#00AEEF"}
                    iconContainerStyles={{ padding: "0px" }}
                    textStyles={{
                      fontFamily: "Open Sans",
                      lineHeight: "19px",
                      whiteSpace: "nowrap",
                    }}
                    title="View Details"
                    color="#00AEEF"
                    icon={<InfoButtonIcon />}
                    clickHandler={() => {
                      window.analytics.track(
                        "Patient-Details-Reports-View-Content-Click"
                      );
                      setOpenReportIndex(idx)
                      setOpenReportDetails(true)
                    }}
                  />
                ),
              })}
              rows={patientReportRow && patientReportRow}
              isLoadingRow={isLoadingReports}
              isPaginated={true}
            />
              {!isLoadingReports && patientReportRow?.length ? (
                <PageContainer>
                  <IconContainer
                    paddingRight="7px"
                    onClick={handlePreviousReportsPage}
                  >
                    <PaginationLeftArrow />  Previous
                  </IconContainer>
                  {` ${reportsPageNumber} of ${totalReportsPages} `}
                  <IconContainer
                    
                    paddingLeft="7px"
                    onClick={handleNextReportsPage}
                  >
                  Next  <PaginationRightArrow />
                  </IconContainer>
                </PageContainer>
              ) : (
                <></>
              )}
          </TableContainer>
          </div>
          </Col>
        </Row>
        <Row id="recommendations" style={{ marginBottom: 30 }}>
          <Col sm={12} lg={12} xl={12}>
            <TableContainer>
            <Heading>Recommendations</Heading>
            <Table
              columns={[].concat(recommendationColumns.slice(0, 6), [
                {
                  key:'conditional',
                  name:'Conditional',
                  displayCell: (cellValue, rowData) => (
                   cellValue? 
                     <ConditionalIcon/>
                   : null
                  ),
                },
                {
                  key: "status",
                  name: "Status",
                  displayCell: (status, row) =>   <>
                <StatusBadge onClick={(e)=>handleClick(e,row.id)} status={status} styles={{marginLeft:0}} />
                  </>  
                },
                {
                  key: "id",
                  displayCell: (value, rowData) => (
                    <TemplateButton
                      style={{
                        height: "38px",
                        borderRadius: "4px",
                        borderWidth: "2px",
                        padding: "9px 15px",
                        width: "130px",
                        gap: "8px",
                      }}
                      iconContainerStyles={{ padding: "0px" }}
                      textStyles={{
                        fontFamily: "Open Sans",
                        lineHeight: "19px",
                        whiteSpace: "nowrap",
                      }}
                      title="View Details"
                      border={true}
                      outlinedBr={"#00AEEF"}
                      color="#00AEEF"
                      icon={<InfoButtonIcon />}
                      clickHandler={() => {
                        window.analytics.track(
                          "Patient-Details-Recommendations-View-Content-Click"
                        );
                        setSelectedData({
                          ...rowData,
                        });
                      }}
                    />
                  ),
                }
              ])}
              rows={patientRecosRow && patientRecosRow}
              isLoadingRow={isLoadingReco}
              isPaginated={true}
              hasSubTable={true}
              subRowKey={'recoHistory'}
              subColumns={recoHistoryData}
            />
              {!isLoadingReco && patientRecosRow?.length ? (
                <PageContainer>
                  <IconContainer
                    paddingRight="7px"
                    onClick={handlePreviousRecommendationsPage}
                  >
                    <PaginationLeftArrow />  Previous
                  </IconContainer>
                  {` ${recommendationsPageNumber} of ${totalRecommendationsPages} `}
                  <IconContainer
                    
                    paddingLeft="7px"
                    onClick={handleNextRecommendationsPage}
                  >
                   Next <PaginationRightArrow />
                  </IconContainer>
                </PageContainer>
              ) : (
                <></>
              )}
            {
              open &&<Popover
              id={popupId}
              open={open}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
              }}
              PaperProps={{
                style: {
                  borderRadius: '10px', 
                  border: '2px solid #DFE0EB',
                  width:'244px',
                  background: '#F7F8FF',
                  boxShadow:'none',
                  marginTop:'10px'
                },
              }}
            >
               <StatusesContainer ref={node}>
                      <ActionStatusList
                        selectedStatus={selectedStatus}
                        id={openedRow}
                        handleSelectStatus={(data) => {
                          if((permission && updatePermission) || !permission){
                          setSelectedStatus(data.status);
                          dispatch(changeActionStatusActionPatientDetails(data.id, data.status)).then(res=>{
                            dispatch(getRecommendationByPatientId(id || patientId));
                            handleClose();
                          })
                          }else{
                            dispatch(
                              showAlert('danger', 'Error', `You don't have permission to update recommendation status`)
                            );
                          }   
                        }
                      }
                        fromMessage
                      />
                </StatusesContainer>
            </Popover>
            }
           
            </TableContainer>
          </Col>
        </Row>
        <Row id="appointments" style={{ marginBottom: 30 }}>
        <Col sm={12} lg={12} xl={12}>
          <TableContainer>
          <Heading>Appointments</Heading>
            <Table
              columns={appointmentsColumns}
              rows={patientAppointmentRow && patientAppointmentRow}
              isLoadingRow={isLoadingAppointments}
              isPaginated={true}
            />
                {!isLoadingAppointments && patientAppointmentRow?.length ? (
                <PageContainer>
                  <IconContainer
                    paddingRight="7px"
                    onClick={handlePreviousAppointmentsPage}
                  >
                    <PaginationLeftArrow />  Previous
                  </IconContainer>
                  {` ${appointmentsPageNumber} of ${totalAppointmentsPages} `}
                  <IconContainer
                    
                    paddingLeft="7px"
                    onClick={handleNextAppointmentsPage}
                  >
                  Next <PaginationRightArrow />
                  </IconContainer>
                </PageContainer>
              ) : (
                <></>
              )}
          </TableContainer>
          
          </Col>
        </Row>
        <Row  id="prescriptions" style={{ marginBottom: 30 }} >
          <Col sm={12} lg={12} xl={12}>
            <TableContainer>
              <Heading style={{ textAlign: "left" }}>Prescriptions</Heading>
              <Table
                columns={prescriptionsColumns}
                rows={prescriptions && prescriptions}
                isLoadingRow={isLoadingPrescriptions}
                isPaginated={true}
              />
              {!isLoadingPrescriptions && prescriptions?.length ? (
                <PageContainer>
                  <IconContainer
                    paddingRight="7px"
                    onClick={handlePreviousPrescriptionPage}
                  >
                    <PaginationLeftArrow /> Previous
                  </IconContainer>
                  {` ${prescriptionPageNumber} of ${totalPrescriptionsPages} `}
                  <IconContainer
                    
                    paddingLeft="7px"
                    onClick={handleNextPrescriptionPage}
                  >
                    Next <PaginationRightArrow />
                  </IconContainer>
                </PageContainer>
              ) : (
                <></>
              )}
            </TableContainer>
          </Col>
        </Row>
        <Row id="cohorts" style={{ marginBottom: 30 }}>
          <Col sm={12} lg={12} xl={12}>
                        <TableContainer>
                          <ContainerHeader>
                           <Heading style={{marginBottom:'0px'}} align="left">Cohorts</Heading>
                          </ContainerHeader>

                            <Table
                               columns={cohortsColumns.concat([{
                                
                                    key: 'viewContent',
                                    displayCell: (value,row) => (<TemplateButton title="View Cohort"    border={true}
                                      outlinedBr={"#00AEEF"} color="#00AEEF" icon={<InfoButtonIcon />} clickHandler={() => {
                                        window.analytics.track('Patient-View-Content-Button-Click');
                                        history.push({
                                            pathname: `/auth/radAdmin/followUp/patients/cohorts/details/${row.id}`,
                                            state: {row}
                                        })
                                    }}   />)
                            
                                
                               }])}
                               rows={cohorts && cohorts}
                               isLoadingRow={isLoadingCohorts}
                               isPaginated={true}
                            />
                            {(!isLoadingCohorts && cohorts?.length) ?
                            <PageContainer>
                                <IconContainer paddingRight="7px" onClick={handlePreviousCohortsPage}><PaginationLeftArrow /> Previous</IconContainer>
                                {` ${cohortsPageNumber} of ${totalCohortsPages} `}
                                <IconContainer  paddingLeft="7px" onClick={handleNextCohortsPage}> Next <PaginationRightArrow/></IconContainer>
                                </PageContainer>
                            : <></>}
                        </TableContainer>
                    </Col>
        </Row>

           <Row id="report-cohorts" style={{ marginBottom: 30 }}>
          <Col sm={12} lg={12} xl={12}>
                        <TableContainer>
                          <ContainerHeader>
                           <Heading style={{marginBottom:'0px'}} align="left">Report Cohorts</Heading>
                          </ContainerHeader>

                            <Table
                               columns={reportCohortsColumns.concat([{
                                
                                    key: 'viewContent',
                                    displayCell: (value,row) => (<TemplateButton title="View Cohort"    border={true}
                                      outlinedBr={"#00AEEF"} color="#00AEEF" icon={<InfoButtonIcon />} clickHandler={() => {
                                        window.analytics.track('Patient-View-Content-Button-Click');
                                        history.push(`/auth/radAdmin/followUp/reports/cohorts/details/${row.id}`, {data: row} )
                                         
                                    }}   />)
                                    
                                
                               }])}
                               rows={reportCohorts && reportCohorts}
                               isLoadingRow={isLoadingReportCohorts}
                               isPaginated={true}
                            />
                            {(!isLoadingReportCohorts && reportCohorts?.length) ?
                            <PageContainer>
                                <IconContainer paddingRight="7px" onClick={handlePreviousReportCohortsPage}><PaginationLeftArrow /> Previous</IconContainer>
                                {` ${reportCohortsPageNumber} of ${totalReportCohortsPages} `}
                                <IconContainer  paddingLeft="7px" onClick={handleNextReportCohortsPage}> Next <PaginationRightArrow/></IconContainer>
                                </PageContainer>
                            : <></>}
                        </TableContainer>
                    </Col>
        </Row>
        <Row id="notes" style={{ marginBottom: 30 }}>
        <Col sm={12} lg={12} xl={12}>
          <TableContainer>
            <ContainerHeader>
              <Heading style={{marginBottom:'0px'}}>Notes</Heading>
              <SaveButton onClick={()=>{
                 if((permission && addPermission) || !permission){
                  setOpenNewNote(true)
                }else{
                  dispatch(
                    showAlert('danger', 'Error', `You don't have permission to create note`)
                  );
                }       
              }}>New Note</SaveButton>
           </ContainerHeader>
            <Table
                columns={notesColumns}
                rows={notesRows && notesRows}
                isLoadingRow={isLoadingNotes}
                isPaginated={true}
              />
              {!isLoadingNotes && notesRows?.length ? (
                <PageContainer>
                  <IconContainer
                    paddingRight="7px"
                    onClick={handlePreviousPage}
                  >
                    <PaginationLeftArrow />  Previous
                  </IconContainer>
                  {` ${pageNumber} of ${totalNotesPages} `}
                  <IconContainer
                    
                    paddingLeft="7px"
                    onClick={handleNextPage}
                  >
                   Next <PaginationRightArrow />
                  </IconContainer>
                </PageContainer>
              ) : (
                <></>
              )}
            </TableContainer>
          </Col>
        </Row>
        <Row id="emails" style={{ marginBottom: 30 }}>
          <Col sm={12} lg={12} xl={12}>
            <TableContainer>
            <Heading align="left">Email</Heading>
              <Table
                columns={emailsColumns.concat([
                  {
                    key: "viewContent",
                    displayCell: (value, row) => (
                      <TemplateButton
                        title="View Content"
                        border={true}
                        outlinedBr={"#00AEEF"}
                        color="#00AEEF"
                        width
                        icon={<InfoButtonIcon />}
                        clickHandler={() => {
                          window.analytics.track(
                            "Patient-Details-Email-View-Content-Click"
                          );
                          setSelectedEmail(row);
                        }}
                        style={{
                          height: "38px",
                          borderRadius: "4px",
                          borderWidth: "2px",
                          padding: "9px 13px",
                          width: "144px",
                          gap: "8px",
                        }}
                        iconContainerStyles={{ padding: "0px" }}
                        textStyles={{
                          fontFamily: "Open Sans",
                          lineHeight: "19px",
                          whiteSpace: "nowrap",
                        }}
                      />
                    ),
                  },
                ])}
                rows={emails && emails}
                isLoadingRow={
                  (isLoadingEmails || isLoadingPatient) && isNull(emails)
                }
                isPaginated={true}
              />
            </TableContainer>
            {
              emails?.length>0 &&   <LoadMoreContainer
              disabled={emails && totalEmails === emails.length}
              onClick={
                emails && totalEmails !== emails.length
                  ? () => LoadMoreEmails()
                  : null
              }
              style={{maxWidth:'912px', margin:'0 auto', marginTop:'30px'}}
            >
              {isLoadingEmails ? (
                <Spinner animation="border" role="status" size="sm" />
              ) : (
                "Load more"
              )}
            </LoadMoreContainer>
            }
          
          </Col>
        </Row>

        <Row id="sms" style={{ marginBottom: 100 }}>
          <Col sm={12} lg={12} xl={12}>
            <TableContainer>
            <Heading align="left">SMS</Heading>
              <Table
                columns={[].concat(
                  messagesColumns.slice(0, 1),
                  [
                    {
                      key: "status",
                      name: "Status",
                      displayCell: (status) => (
                        <MessageStatus status={status}  styles={{marginLeft:0}}/>
                      ),
                    },
                  ],
                  messagesColumns.slice(2, messagesColumns.length - 1),
                  [
                    {
                      key: "viewContent",
                      displayCell: (value, row) => (
                        <TemplateButton
                          title="View Content"
                          color="#00AEEF"
                          border={true}
                          outlinedBr={"#00AEEF"}
                          width
                          icon={<InfoButtonIcon />}
                          clickHandler={() => {
                            window.analytics.track(
                              "Patient-Details-Messages-View-Content-Click"
                            );
                            setSelectedMessage(row);
                          }}
                          style={{
                            height: "38px",
                            borderRadius: "4px",
                            borderWidth: "2px",
                            padding: "9px 13px",
                            width: "144px",
                            gap: "8px",
                          }}
                          iconContainerStyles={{ padding: "0px" }}
                          textStyles={{
                            fontFamily: "Open Sans",
                            lineHeight: "19px",
                            whiteSpace: "nowrap",
                          }}
                        />
                      ),
                    },
                  ]
                )}
                rows={messages && messages}
                isLoadingRow={
                  (isLoadingMessages || isLoadingPatient) && isNull(messages)
                }
                isPaginated={true}
              />
            </TableContainer>
            {
              messages?.length>0 &&    <LoadMoreContainer
              disabled={messages && totalMessages === messages.length}
              onClick={
                messages && totalMessages !== messages.length
                  ? () => LoadMoreMessages()
                  : null
              }
              style={{maxWidth:'912px', margin:'0 auto',  marginTop:'30px'}}
            >
              {isLoadingMessages ? (
                <Spinner animation="border" role="status" size="sm" />
              ) : (
                "Load more"
              )}
            </LoadMoreContainer>
            }
          
          </Col>
        </Row>

        <Row id="letters" style={{ marginBottom: 30 }}>
          <Col sm={12} lg={12} xl={12}>
            <TableContainer>
            <Heading>Letters</Heading>
            <Table
              columns={[].concat(lettersColumns.slice(0, 6), [
                {
                  key: "id",
                  name: 'Letter',
                  displayCell: (value, rowData) => (
                    <TemplateButton
                     border={true}
                    outlinedBr={"#00AEEF"}
                    style={{
                      height: "38px",
                      borderRadius: "4px",
                      borderWidth: "2px",
                      padding: "9px 15px",
                      width: "130px",
                      gap: "8px",
                    }}
                    iconContainerStyles={{ padding: "0px" }}
                    textStyles={{
                      fontFamily: "Open Sans",
                      lineHeight: "19px",
                      whiteSpace: "nowrap",
                    }}
                    title="View PDF"
                    color="#00AEEF"
                    icon={<InfoButtonIcon />}
                    clickHandler={() => {
                      window.analytics.track(
                        "Patient-Details-Letters-Click"
                      );
                      setSelectedLetters({
                        ...rowData,
                        recipient_email: patientDetails?.email
                      });
                    }}
                  />
                  ),
                }
              ])}
              rows={patientLettersRow && patientLettersRow}
              isLoadingRow={(isLoadingLetters || isLoadingPatient) && isNull(patientLettersRow)}            
              isPaginated={true}
            />

            {
              patientLettersRow?.length>0 && <LoadMoreContainer
              disabled={patientLettersRow && totalLetters === patientLettersRow?.length}
              onClick={
                patientLettersRow && totalLetters !== patientLettersRow?.length
                  ? () => LoadMoreLetters()
                  : null
              }
              style={{maxWidth:'912px', margin:'0 auto', marginTop:'30px'}}
            >
              {isLoadingLetters ? (
                <Spinner animation="border" role="status" size="sm" />
              ) : (
                "Load more"
              )}
            </LoadMoreContainer>
            }
             {
              letterOpen &&<Popover
              id={letterPopupId}
              open={letterOpen}
              anchorEl={letterAnchorEl}
              onClose={handleLetterClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
              }}
              PaperProps={{
                style: {
                  borderRadius: '10px', 
                  border: '2px solid #DFE0EB',
                  width:'125px',
                  background: '#F7F8FF',
                  boxShadow:'none',
                  marginTop:'10px'
                },
              }}
            >
                  <ActionList>
                  {
                    actionStatuses?.filter(itm=>itm.value!==openedLetterRow?.status).map(({status, color, value}) => (
                      <ActionItem key={status} onClick={() => {
                        if((permission && updatePermission) || !permission){
                          dispatch(changeLetterStatusPatientDetails(openedLetterRow?.id, {status: value})).then(res=>{
                            handleLetterClose();
                          })
                          }else{
                            dispatch(
                              showAlert('danger', 'Error', `You don't have permission to update letter status`)
                            );
                          }   
                        
                      }}><ActionStatus status={status} color={color} selectedStatus={selectedStatus} fromMessage="true"/></ActionItem>
                    ))
                  }
          </ActionList>
            </Popover>
            }
            </TableContainer>
          
          </Col>
        </Row>


          <Row id="faxes" style={{ marginBottom: 30 }}>
          <Col sm={12} lg={12} xl={12}>
            <TableContainer>
            <Heading>Faxes</Heading>
            <Table
              columns={[].concat(
                  faxesColumns.slice(0, 1),
                  [
                    {
                      key: "status",
                      name: "Status",
                      align:'start',
                      displayCell: (status) => (
                        <FaxStatus status={status}  styles={{marginLeft:0}}/>
                      ),
                    },
                  ],
                  faxesColumns.slice(2, faxesColumns.length - 1),
                  [
                    {
                      key: "viewContent",
                      displayCell: (value, row) => (
                        <TemplateButton
                          title="View Content"
                          color="#00AEEF"
                          border={true}
                          outlinedBr={"#00AEEF"}
                          width
                          icon={<InfoButtonIcon />}
                          clickHandler={() => {
                            window.analytics.track(
                              "Patient-Details-Faxes-View-Content-Click"
                            );
                            setSelectedFax(row);
                          }}
                          style={{
                            height: "38px",
                            borderRadius: "4px",
                            borderWidth: "2px",
                            padding: "9px 13px",
                            width: "144px",
                            gap: "8px",
                          }}
                          iconContainerStyles={{ padding: "0px" }}
                          textStyles={{
                            fontFamily: "Open Sans",
                            lineHeight: "19px",
                            whiteSpace: "nowrap",
                          }}
                        />
                      ),
                    },
                  ]
                )}
              rows={patientFaxesRow && patientFaxesRow}
              isLoadingRow={(isLoadingFaxes || isLoadingPatient) && isNull(messages)}            
              isPaginated={true}
            />
          </TableContainer>
            {
              patientFaxesRow?.length>0 && <LoadMoreContainer
              disabled={patientFaxesRow && totalFaxes === patientFaxesRow?.length}
              onClick={
                patientFaxesRow && totalFaxes !== patientFaxesRow?.length
                  ? () => LoadMoreFaxes()
                  : null
              }
              style={{maxWidth:'912px', margin:'0 auto', marginTop:'30px'}}
            >
              {isLoadingFaxes ? (
                 <Spinner animation="border" role="status" size="sm" />
                ) : (
                  "Load more"
                )}
              </LoadMoreContainer>
              }
              </Col>
              </Row>
        <Row id="secured-sms" style={{ marginBottom: 100 }}>
          <Col sm={12} lg={12} xl={12}>
            <TableContainer>
            <Heading align="left">Secured SMS</Heading>
              <Table
                columns={securedMessagesColumns}
                rows={patientSecuredSMSRow && patientSecuredSMSRow}
                isLoadingRow={
                  (isLoadingSecuredSMS || isLoadingPatient) && isNull(patientSecuredSMSRow)
                }
                isPaginated={true}
              />
            </TableContainer>
            {
              patientSecuredSMSRow?.length>0 &&    <LoadMoreContainer
              disabled={patientSecuredSMSRow && totalSecuredSMS === patientSecuredSMSRow.length}
              onClick={
                patientSecuredSMSRow && totalSecuredSMS !== patientSecuredSMSRow.length
                  ? () => LoadMoreSecuredSMS()
                  : null
              }
              style={{maxWidth:'912px', margin:'0 auto',  marginTop:'30px'}}
            >
              {isLoadingSecuredSMS ? (
                <Spinner animation="border" role="status" size="sm" />
              ) : (
                "Load more"
              )}
            </LoadMoreContainer>
            }
                    
          </Col>
        </Row>

        <Row id="secured-sms" style={{ marginBottom: 100 }}>
          <Col sm={12} lg={12} xl={12}>
            <TableContainer>
            <Heading align="left">Secured SMS</Heading>
              <Table
                columns={securedMessagesColumns}
                rows={patientSecuredSMSRow && patientSecuredSMSRow}
                isLoadingRow={
                  (isLoadingSecuredSMS || isLoadingPatient) && isNull(patientSecuredSMSRow)
                }
                isPaginated={true}
              />
            </TableContainer>
            {
              patientSecuredSMSRow?.length>0 &&    <LoadMoreContainer
              disabled={patientSecuredSMSRow && totalSecuredSMS === patientSecuredSMSRow.length}
              onClick={
                patientSecuredSMSRow && totalSecuredSMS !== patientSecuredSMSRow.length
                  ? () => LoadMoreSecuredSMS()
                  : null
              }
              style={{maxWidth:'912px', margin:'0 auto',  marginTop:'30px'}}
            >
              {isLoadingSecuredSMS ? (
                <Spinner animation="border" role="status" size="sm" />
              ) : (
                "Load more"
              )}
            </LoadMoreContainer>
            }
          
          </Col>
        </Row>
        {selectedEmail && (
          <ShowMessageContent
            messageContent={selectedEmail.content}
            show={!isNull(selectedEmail)}
            dialogHandler={dialogHandler}
            recipientEmail={selectedEmail.recipient_email}
            sourceEmail={recoConfigData?.name || "-"}
            customHeader="Email Content"
            isEmailType={true}
          />
        )}
        {selectedMessage && (
          <ShowMessageContent
            messageContent={selectedMessage.message}
            show={!isNull(selectedMessage)}
            dialogHandler={dialogHandler}
            patientPhoneNumber={selectedMessage.patient_phone_number}
            twilioPhoneNumber={selectedMessage.twilio_phone_number}
          />
        )}
         {selectedLetters && (
          <ShowMessageContent
            messageContent={selectedLetters.content}
            show={!isNull(selectedLetters)}
            dialogHandler={dialogHandler}
            recipientEmail={selectedPatientFirstName +" "+ selectedPatientLastName ||"---"}
            sourceEmail={recoConfigData?.name || "-"}
            customHeader="Letter Content"
            isEmailType={true}
          />
        )}

         {selectedFax && (
          <ShowMessageContent
            messageContent={ selectedFax.attachment}
            show={!isNull(selectedFax)}
            dialogHandler={dialogHandler}
            recipientFax={selectedFax?.fax}
            sourceEmail={selectedFax?.direction ==="inbound"? (selectedFax?.fax ?? "-") : recoConfigData?.name}
            customHeader="Fax Content"
            isPdf={true}
          />
        )}
      </Container>

      {selectedData && isSelectedData && (
        <EditReco
          openDialog={selectedData !== null}
          selectedData={
            {...requiredReco}
          }
          editModalHandle={editModalHandle}
          activeStatus={selectedData.status}
          chevronHandler={chevronHandler}
          fromPatientDetails={true}
          setSelectedData={setSelectedData}
        />
      )}
         {openNewNote && <NewNote openDialog={openNewNote} addNoteClickHandler={addNoteClickHandler} selectedData={{patientId: id || patientId}} setNotesPage={setPageNumber} />
                }

        {openReportDetails && (
          <ViewReportModal
            data={patientReportRow[openReportIndex]}
            showModal={openReportDetails}
            closeModal={() => {
              setOpenReportIndex()
              setOpenReportDetails(false)
            }}
            handlePrev={()=>{ 
              if(openReportIndex>0){
                setOpenReportIndex(prev=>prev -1)
              }
            }}
            handleNext={()=>{
              if(openReportIndex === patientReportRow.length -1 && totalReports !== patientReportRow.length){
                handleNextReportsPage()
                setOpenReportIndex(prev=>prev +1)
              }
              else if(openReportIndex<patientReportRow.length -1){
                setOpenReportIndex(prev=>prev +1)
              }
             
          }}
          isPaginated={true}
          disabledPrev={openReportIndex === 0}
          disabledNext={openReportIndex ===patientReportRow.length -1 && !(totalReports !== patientReportRow?.length)}
          isLoading={isLoadingReports}
          />
        )}
    </>
  );
};

export default PatientDetails;
